/* ============
 * Mutations for the assessment module
 * ============
 *
 * The mutations that are available on the
 * assessment module.
 */

import types from './mutation-types';

export default {
  [types.FETCH_ASSESSMENTS](state) {
    state.assessmentLoading = true;
  },
  [types.FETCH_ASSESSMENTS_SUCCESS](state, res) {
    state.assessmentLoading = false;
    state.assessments = res.patients;
    state.totalCount = res.totalCount;
    state.alertCount = res.alertCount;
  },
  [types.FETCH_ASSESSMENTS_FAIL](state, error) {
    state.assessmentLoading = false;
    state.error = error;
  },

  [types.FETCH_ASSESSMENT_SYMPTOMS](state) {
    state.assessmentLoading = false;
  },

  [types.FETCH_ASSESSMENT_SYMPTOMS_SUCCESS](state, res) {
    state.assessmentLoading = false;
    state.assessmentSymptoms =  res.assessmentSymptom;
  },

  [types.FETCH_ASSESSMENT_SYMPTOMS_FAIL](state, error) {
    state.assessmentLoading = false;
    state.error = error;
  }

};
